import React from 'react';
import ArrayRailsSides from './ArrayRailsSides';
import ArrayRailsWidth from './ArrayRailsWidth';

const Component = (props) => (
  <div className="row">
    <div className="col-md-6">
      <ArrayRailsSides {...props} />
    </div>
    <div className="col-md-6">
      <ArrayRailsWidth {...props} />
    </div>
  </div>
);

Component.defaultProps = {
  label: 'Rail Width',
  required: false,
  tooltip: 'All rails have a width of 0.5 inches.',
};

export default Component;
